// extracted by mini-css-extract-plugin
module.exports = {"B_slider":"Slider_B_slider__30Pt7"};